<div class="full-page" [style.background-image]="'url(' + ('login-registration/login-background.jpg' | contentAssetImage) + ')'">
  <div class="container">
    <img [src]="'logos/login-logo.svg' | contentAssetImage" class="logo" />

    <div class="bg-white content-login">
      <h5 class="title fw-bold text-primary text-uppercase">{{ 'login.page.title' | translate }}</h5>

      <p class="description font-size-14">{{ 'login.page.description' | translate }}</p>

      <div class="w-100">
        <fgb-seatgeek-user-login></fgb-seatgeek-user-login>
        <ng-container *ngIf="errorCode$ | async as errorCode">
          <div class="text-danger text-center mt-5 fw-bold">
            {{ errorCode | translate }}
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
